import { render, staticRenderFns } from "./Cm-ig-embed.vue?vue&type=template&id=7a8a4f41&scoped=true"
import script from "./Cm-ig-embed.vue?vue&type=script&lang=js"
export * from "./Cm-ig-embed.vue?vue&type=script&lang=js"
import style0 from "./Cm-ig-embed.vue?vue&type=style&index=0&id=7a8a4f41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8a4f41",
  null
  
)

export default component.exports